import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { IconButtonProps } from '@mui/material/IconButton/IconButton';
import type { FC } from 'react';

export const ArrowForwardCell: FC<IconButtonProps> = props => {
  const { t } = useTranslation();

  return (
    <IconButton
      aria-label={t(
        'GSP.pages.progress.widgets.latestGrades.actionCell.arrowForwardCell.ariaLabel',
      )}
      {...props}
    >
      <ArrowForwardIcon color="action" />
    </IconButton>
  );
};
